import { render, staticRenderFns } from "./TeacherLayout.vue?vue&type=template&id=11a37a77&scoped=true"
import script from "./TeacherLayout.vue?vue&type=script&lang=js"
export * from "./TeacherLayout.vue?vue&type=script&lang=js"
import style0 from "./TeacherLayout.vue?vue&type=style&index=0&id=11a37a77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a37a77",
  null
  
)

export default component.exports